module.exports = __webpack_public_path__ + "img/logo-asaas.88495e37.svg";